module.exports = __webpack_public_path__ + "img/print.bfe2681a.png";